export type Variant = {
  name: string;
  weight: number;
};

export type Experiment = {
  id: number;
  name: string;
  description: string;
  variants: Variant[];
  enabled: boolean;
  urlParam?: string;
};

const oneThird = 100 / 3;

const experiments = {
  landingPageTest: {
    id: 52,
    name: 'Tours and food tours landing page test',
    description:
      'This will test three different variations of the landing page',
    variants: [
      { name: 'ueSearch', weight: oneThird },
      { name: 'ueLandingPage', weight: oneThird },
      { name: 'storefrontLandingpage', weight: oneThird },
    ],
    enabled: true,
    urlParam: 'lpt',
  },
  marvinTest: {
    id: 57,
    name: 'Marvin entrypoint',
    description: 'Show Marvin entrypoint on the homepage',
    variants: [
      { name: 'Default', weight: 90 },
      { name: 'Show Marvin entrypoint', weight: 10 },
    ],
    enabled: true,
  },
  hideTopThingsToDoSlider: {
    id: 58,
    name: 'Hide top things to do slider',
    description: 'Hide top things to do slider from the search page',
    variants: [
      { name: 'Default', weight: 50 },
      { name: 'Hide top things to do slider', weight: 50 },
    ],
    enabled: true,
  },
  appLoginFirstScreen: {
    id: 59,
    name: 'App Login First Screen',
    description:
      'Shows signup screen as the first screen for non-logged-in users on the mobile app',
    variants: [
      { name: 'Control - HomeScreen first', weight: 50 },
      { name: 'Signup screen first', weight: 50 },
    ],
    enabled: true,
  },
} satisfies Record<string, Experiment>;

export type ExperimentName = keyof typeof experiments;

export function getExperimentById(id: number): Experiment | undefined {
  return Object.values(experiments).find((exp) => exp.id === id);
}

export function getExperimentByName(name: ExperimentName): Experiment {
  return experiments[name];
}

export function getAllExperiments(): Experiment[] {
  return Object.values(experiments);
}

export function getAllExperimentEntries(): [ExperimentName, Experiment][] {
  return Object.entries(experiments) as [ExperimentName, Experiment][];
}
